/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberAppointmentsIdStartMutationResponse, PostApiBarberAppointmentsIdStartPathParams, PostApiBarberAppointmentsIdStart400, PostApiBarberAppointmentsIdStart401, PostApiBarberAppointmentsIdStart403, PostApiBarberAppointmentsIdStart404, PostApiBarberAppointmentsIdStart500 } from "../entities/PostApiBarberAppointmentsIdStart";

function getPostApiBarberAppointmentsIdStartUrl(id: PostApiBarberAppointmentsIdStartPathParams["id"]) {
  const res = { method: 'POST', url: `/api/barber/appointments/${id}/start` as const }
  return res
}

/**
 * @description Мастер начинает обслуживание после вызова клиента
 * @summary Начать обслуживание
 * {@link /api/barber/appointments/:id/start}
 */
export async function postApiBarberAppointmentsIdStart(id: PostApiBarberAppointmentsIdStartPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiBarberAppointmentsIdStartMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdStart400 | PostApiBarberAppointmentsIdStart401 | PostApiBarberAppointmentsIdStart403 | PostApiBarberAppointmentsIdStart404 | PostApiBarberAppointmentsIdStart500>, unknown>({ method : "POST", url : getPostApiBarberAppointmentsIdStartUrl(id).url.toString(), ... requestConfig })
  return res.data
}